module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail4.ff45d60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail4.jpg
// module id = 7mlk
// module chunks = 5